import { useQuery } from "@tanstack/react-query";
import { getCurrentUserEmail } from "@/lib/auth";
import { getUserByEmail } from "@/services/userManagementApi";

export const useCurrentUserRole = () => {
  return useQuery({
    queryKey: ["current_user_role"],
    queryFn: async () => {
      const email = getCurrentUserEmail();
      if (!email) return null;
      try {
        const user = await getUserByEmail(email);
        const role = user.roles?.[0];
        if (!role) return null;
        // API may return a role object {id, name, ...} instead of a plain string
        return typeof role === 'string' ? role : (role as any).name || null;
      } catch {
        return null;
      }
    },
  });
};
